<template>
  <div>
    <div v-if="components.bottom_sheet.option_index==4">
      <div style="text-align:center;color:rgb(5,47,102);">
        <h6><b>MAKE A COMPLAINT</b></h6>
      </div>
      <div style="text-align:center;color:rgb(5,47,102)">
        <p>Please provide your complaint details below</p>
      </div>
    </div>
    <div  v-else-if="components.bottom_sheet.option_index==5">
      <div style="text-align:center;color:rgb(5,47,102)">
        <h6>GIVE A COMPLIMENT</h6>
      </div>
      <div style="text-align:center;color:rgb(5,47,102)">
        <p>Please provide your compliment details below</p>
      </div>
    </div>
    <div style="padding-left:20px;padding-right:20px">
        <div style="background-color:transparent;padding-bottom:10px">            
          <v-form ref="form">
            <v-row class="ma-0 pa-0"
            >
              <v-col
                class="ma-0 pa-0"
                cols="12"
                sm="3"
              >                   
                <v-text-field v-if="user.loggedIn"
                  label="First name"                        
                  v-model="user.data.first_name"                    
                  dense            
                  style="padding-right:5px"
                  outlined
                >  
                </v-text-field>
                <v-text-field v-else
                  label="First name"                        
                  v-model="custom.first_name"                       
                  dense            
                  style="padding-right:5px"
                  outlined
                >  
                </v-text-field>
              </v-col>
              <v-col 
                class="ma-0 pa-0"
                cols="12"
                sm="3"
              > 
                <v-text-field v-if="user.loggedIn"
                  label="Last name"
                  v-model="user.data.last_name"                     
                  dense                       
                  style="padding-right:5px"
                  outlined
                >  
                </v-text-field>
                <v-text-field v-else
                  label="Last name"
                  v-model="custom.last_name"                    
                  dense                       
                  style="padding-right:5px"
                  outlined
                >  
                </v-text-field>
              </v-col>
              <v-col
                class="ma-0 pa-0"
                cols="12"
                sm="3"
              >    
                <v-text-field v-if="user.loggedIn"
                  label="Email address"
                  v-model="user.data.email_address"                      
                  dense            
                  style="padding-right:5px" 
                  outlined
                >  
                </v-text-field>
                <v-text-field v-else
                  label="Email address"
                  v-model="custom.email_address"                    
                  dense            
                  style="padding-right:5px" 
                  outlined
                >  
                </v-text-field>
              </v-col>
              <v-col
                class="ma-0 pa-0"
                cols="12"
                sm="3"
              >   
                <v-text-field v-if="user.loggedIn"
                  label="Mobile number"
                  v-model="user.data.phone_number"                      
                  dense            
                  outlined
                >  
                </v-text-field>
                <v-text-field v-else
                  label="Mobile number"
                  v-model="custom.phone_number"                    
                  dense                   
                  outlined                 
                >  
                </v-text-field>
              </v-col>
            </v-row>
            
                <v-textarea v-if="components.bottom_sheet.option_index==4"
                  label="Complaint"                  
                  v-model="complaint"                    
                  outlined                                      
                >  
                </v-textarea>   
                <v-textarea v-else
                  label="Compliment"
                  v-model="complaint"                    
                  outlined  
                >  
                </v-textarea>
              
          </v-form>                     
          <v-btn
            text
            @click="submit"
            outlined
          >
            Submit
          </v-btn>
          <v-btn 
            outlined
            style="margin-left:5px"
            text
            @click="components.bottom_sheet.is_open = false"
          >
            Cancel
          </v-btn>
        </div>
      </div>
  </div>
</template>
<script>
  import { mapGetters } from "vuex";
  import axios from "axios";

  //const URL = "http://35.242.182.168/services/complaintsComplimentsApi/public/complaint-compliments";
  const URL = `http://35.242.182.168/microservices/ComplaintsApi/public/complaints`;

  export default {
    name: 'Complaints',
    data: () => ({
      custom: {
        first_name: '',
        last_name: '',
        email_address: '',
        phone_number: ''
      },
      complaint: ''
    }),
    methods: {
      closeSheet(){
        this.components.bottom_sheet.is_open=false;
        this.components.bottom_sheet.option_index=0;
      },
      showAlert(){
        this.components.bootstrap_alert.dismissCountDown = this.components.bootstrap_alert.dismissSecs;
        this.components.bootstrap_alert.variant = 'success';

        if (this.components.bottom_sheet.option_index==4){
          this.components.bootstrap_alert.alert_text = 'Complaint submission successful!';
        }else{
          this.components.bootstrap_alert.alert_text = 'Compliment submission successful!';
        }
      },
      submit() {
        if (this.$refs.form.validate()){
          this.loading = true;

          var full_name = "";
          var email_address = "";
          var dial_code = "";
          var phone_number = "";

          if (this.user.loggedIn){
            full_name = this.user.data.first_name + " " + this.user.data.last_name;
            email_address = this.user.data.email_address;
            phone_number = this.user.data.phone_number;
          }else{
            full_name = this.custom.first_name + " " + this.custom.last_name;
            email_address = this.custom.email_address;
            phone_number = this.custom.phone_number;
          }

          var n = phone_number.length;
          var mobile_number = "";

          if (n > 12){
            dial_code = phone_number.substring(0,4);
            mobile_number = phone_number.substring(4,n);
          }

          var data = {
            name: full_name,
            email: email_address,
            dial_code: dial_code,
            phone_number: mobile_number,
            message: this.complaint,
            channel: 'Website'
          }

          const headers = {
            'Content-Type': 'application/json',
            'Authorisation': 'e9jiqUN6skAPXcFyUu4zTLV93DSIJxgO'
          }   

          axios
          .post(URL,data,{ "headers": headers})
          .then(response => {              
              console.log(response);
              //display alert
              this.showAlert();
              this.complaint = '';
          })
          .catch(error => {
              console.log(error);
          });     
          
          //close bottom sheet
          //this.closeSheet();
          
        }
      },
    },
    computed: {
      ...mapGetters({
        user: "user",
        components: "components"
      }),
    },
    updated() {
      
    },
    created(){
      
    }
  }
</script>
